import SessionService from "../../server/session";
import AccessesService from "../../server/accesses";
import DocumentsService from "../../server/document";
import LocationService from "../../server/location";
import systemSettingsServer from "../../server/systemSettings";
import patientServer from "../../server/patient";

const sessionStore = {
  namespaced: true,
  state: {
    user: {},
    patients: [],
    documents: [],
    documentsLoaded: false,
    location: {},
    systemSettings: {},
    isPaying: false,
  },
  getters: {
    user: state => state.user,
    patients: state => state.patients,
    documents: state => state.documents,
    documentsLoaded: state => state.documentsLoaded,
    signalRAppUrl: state => state.systemSettings.signalRAppUrl
  },
  mutations: {
    setUser: (state, user) => (state.user = user),
    setPatients: (state, patients) => (state.patients = patients),
    setDocuments: (state, documents) => (state.documents = documents),
    setDocumentsLoaded: (state, newState) => (state.documentsLoaded = newState),
    setLocation: (state, location) => (state.location = location),
    setSystemSettings: (state, systemSettings) =>
      (state.systemSettings = systemSettings),
    setIsPaying: (state, value) => (state.isPaying = value),
  },
  actions: {
    loadCurrentUser({ commit }) {
      if (SessionService.isLogged()) {
        const user = SessionService.getUser();
        if (user !== null) {
          commit("setUser", user);
          LocationService.get(user.LocationId).then(location => {
            commit("setLocation", location.data);
          });
        }
      }
    },
    loadPatients({ commit }) {
      if (SessionService.isLogged()) {
        AccessesService.patientsByAuth()
          .then(res => {
            commit("setPatients", res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    loadDocuments({ commit }) {
      if (SessionService.isLogged()) {
        DocumentsService.getAll()
          .then(res => {
            commit("setDocuments", res.data);
            commit("setDocumentsLoaded", true);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    loadSystemSettings({ commit }) {
      systemSettingsServer
        .get()
        .then(res => {
          commit("setSystemSettings", res.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadCurrentLocation({ commit, state }) {
      if (SessionService.isLogged()) {
        if (state.user) {
          var location = await LocationService.get(state.user.LocationId);
          if (location) commit("setLocation", location.data);
        }
      }
    },
    async verifyPayment({ commit }, patientId) {
      await patientServer.processPatientPayment(patientId)
      commit('setIsPaying', false);
    }
  }
};

export default sessionStore;
